export default "/images/dots.png?3aa9c0e56ce0acbd61da86d52ad58778";